import React from 'react';
import styled from 'styled-components';
import { Absolute } from '../Absolute/Absolute';
import { Box } from '../Box/Box';
import { getPaletteColor } from '../utils/utils';
const alphaColor = (color, props) => `${getPaletteColor(color)(props)}4C`;
const AbsoluteInput = /*#__PURE__*/styled.input.withConfig({
  displayName: "Toggle__AbsoluteInput",
  componentId: "sc-1yr4x8a-0"
})(["position:absolute;z-index:1;opacity:0;width:100%;height:100%;top:0;left:0;margin:0;cursor:", ";"], props => props.disabled ? 'not-allowed' : 'pointer');
const OutlineAbsolute = /*#__PURE__*/styled(Absolute).withConfig({
  displayName: "Toggle__OutlineAbsolute",
  componentId: "sc-1yr4x8a-1"
})(["height:calc(100% + 8px);opacity:0;background-color:", ";"], props => alphaColor(props.isOn ? 'primary.base' : 'background.dark', props));
const CircleAbsolute = /*#__PURE__*/styled(Absolute).withConfig({
  displayName: "Toggle__CircleAbsolute",
  componentId: "sc-1yr4x8a-2"
})(["display:flex;justify-content:center;align-items:center;height:", ";cursor:", ";z-index:2;transition:left 0.3s;"], props => props.width, props => props.disabled ? 'not-allowed' : 'pointer');
const WrapperBox = /*#__PURE__*/styled(Box).withConfig({
  displayName: "Toggle__WrapperBox",
  componentId: "sc-1yr4x8a-3"
})(["position:relative;height:", "px;transition:background-color 0.15s ease 0s;min-width:", "px;", ":focus-visible + ", "{opacity:1;}&:hover:not([disabled]){background-color:", ";}&:hover:not([disabled]) > #circle-handle{box-shadow:", ";}"], props => props.height, props => props.width, AbsoluteInput, OutlineAbsolute, props => `${getPaletteColor(props.isOn ? 'primary.dark' : 'background.tone')(props)}`, props => props.theme.shadows.xl);
/**
 * Toggle component
 *
 * @public
 */
export function Toggle({
  isOn = false,
  label,
  onToggle,
  disabled,
  height = 24,
  icon,
  name
}) {
  const width = height * 1.875;
  const circleAbsoluteSize = height - 4;
  const leftToggleOnPosition = width - circleAbsoluteSize - 2;
  return React.createElement(WrapperBox, {
    borderRadius: 'full',
    color: disabled ? 'background.light' : isOn ? 'primary.base' : 'background.dark',
    height: height,
    isOn: isOn,
    width: width,
    disabled: disabled,
    onClick: disabled ? null : onToggle
  }, React.createElement(AbsoluteInput, {
    "aria-checked": isOn,
    "aria-label": label,
    checked: isOn,
    disabled: disabled,
    onChange: () => {},
    p: 0,
    role: 'switch',
    tabIndex: '0',
    type: 'checkbox',
    name: name
  }), React.createElement(OutlineAbsolute, {
    borderRadius: 'full',
    isOn: isOn,
    left: '-4px',
    top: '-4px',
    width: 'calc(100% + 8px)'
  }), React.createElement(CircleAbsolute, {
    borderRadius: 'full',
    color: 'background.lightest',
    left: isOn ? leftToggleOnPosition : '2px',
    top: '2px',
    id: 'circle-handle' // added for testing purpose
    ,
    width: `${circleAbsoluteSize}px`,
    boxShadowSize: 'sm',
    disabled: disabled,
    "data-testid": 'handle-div'
  }, icon));
}
Toggle.displayName = 'Toggle';